<h3 mat-dialog-title class="lt">{{ 'LABEL.CHANGE_NAME' | translate }}</h3>
<mat-dialog-content>
    <form [formGroup]="form" class="flex-col lt change-name">
        <label for="firstname-change" class="label-control">{{ 'LABEL.FIRST_NAME' | translate }}</label>
        <mat-form-field color="accent" appearance="outline" class="form">
            <input formControlName="first_name" matInput [placeholder]="'LABEL.FIRST_NAME' | translate" id="firstname-change">
            <mat-icon matPrefix>person</mat-icon>
            <!-- <mat-hint>Hint</mat-hint> -->
        </mat-form-field>
        <!-- <mat-error @fade *ngIf="firstName.errors?.required && firstName.touched">{{ 'MSG.FIRST_NAME_REQUIRED' | translate }}</mat-error> -->

        <label for="lastname-change" class="label-control">{{ 'LABEL.LAST_NAME' | translate }}</label>
        <mat-form-field color="accent" appearance="outline" class="form">
            <input formControlName="last_name" matInput [placeholder]="'LABEL.LAST_NAME' | translate" id="lastname-change">
            <mat-icon matPrefix>person</mat-icon>
            <!-- <mat-hint>Hint</mat-hint> -->
        </mat-form-field>
        <!-- <mat-error @fade *ngIf="lastName.errors?.required && lastName.touched">{{ 'MSG.LAST_NAME_REQUIRED'| translate }}</mat-error> -->

        <label for="gender-change" class="label-control">{{ 'LABEL.GENDER' | translate }}</label>
        <mat-form-field color="accent" appearance="outline"  class="form">
            <mat-select formControlName="gender" class="option">
                <mat-option value="M">{{'GENDER.M' | translate }}</mat-option>
                <mat-option value="F">{{'GENDER.F' | translate }}</mat-option>
            </mat-select>
            <mat-icon matPrefix svgIcon="gender"></mat-icon>
        </mat-form-field>
        <!-- <ng-container *ngIf="gender.errors">
            <mat-error *ngIf="gender.errors.required && gender.touched">{{'MSG.GENDER_REQUIRED' | translate}}</mat-error>
        </ng-container>
        <mat-error *ngIf="form.errors?.unknow">{{ 'MSG.SOMETHINK_WORNG' | translate }}</mat-error> -->
    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-flat-button color="warn" mat-dialog-close>{{ 'LABEL.CANCEL' | translate }}</button>
    <button mat-flat-button color="accent" (click)="onSubmit()" [disabled]="processing">{{ 'LABEL.OK' | translate }}</button>
</mat-dialog-actions>
